<template>
  <v-card class="cardBody" tile>
    <v-row justify="center" align="center" style="height: 100%">
      <v-col>
        <v-card class="mx-auto" max-width="600">
          <v-card-text class="pb-0">
            <v-row align="center">
              <v-col cols="5" class="pb-0">
                <v-img
                  class="mx-auto"
                  :src="require('@/assets/logo.jpg')"
                  contain
                  width="170"
                  height="170"
                ></v-img>
              </v-col>
              <v-col cols="7" class="pb-0" v-if="logueado">
                <v-col>
                  <div class="display-1 text-center">BIENVENIDO</div>
                </v-col>
                <v-col cols="12">
                  <v-list dense>
                    <v-subheader>SOLICITUDES</v-subheader>
                    <v-list-item-group>
                      <v-list-item :to="{ name: 'SolicitudGrabaciones' }">
                        <v-list-item-content>
                          <v-list-item-title
                            >Nueva solicitud de grabación</v-list-item-title
                          >
                        </v-list-item-content>

                        <v-list-item-icon>
                          <v-icon>fas fa-plus</v-icon>
                        </v-list-item-icon>
                      </v-list-item>

                      <v-list-item :to="{ name: 'SolicitudInformacion' }">
                        <v-list-item-content>
                          <v-list-item-title
                            >Nueva solicitud de reclamo</v-list-item-title
                          >
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-icon>fas fa-plus</v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-col>
              <v-col cols="7" class="pb-0" v-else>
                <v-col>
                  <div class="display-1 text-center">INICIO DE SESION</div>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Correo"
                    v-model="usuario"
                    prepend-icon="fas fa-user"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Contraseña"
                    v-model="contraseña"
                    prepend-icon="fas fa-unlock-alt"
                    type="password"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="cerrarSesion()" v-if="logueado">
              Cerrar sesion
            </v-btn>
            <v-btn color="primary" @click="login()" v-else> Entrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay v-model="loading">
      <lottie-player
        autoplay
        loop
        mode="normal"
        src="https://assets7.lottiefiles.com/packages/lf20_OdNgAj.json"
        style="width: 500px"
        background="transparent"
      >
      </lottie-player>
    </v-overlay>
  </v-card>
</template>
<script>
import Header from "../components/Header.vue";
import { instanceWeb, dbRealtimeUser } from "../main";
import "@lottiefiles/lottie-player";

export default {
  name: "Login",
  components: {
    Header,
  },
  data() {
    return {
      usuario: "",
      contraseña: "",
      alert: false,
      logueado: false,
      loading: false,
    };
  },
  created() {
    this.verificarAuth();
  },
  methods: {
    login() {
      let me = this;
      if (me.usuario && me.contraseña) {
        me.loading = true;
        instanceWeb
          .auth()
          .signInWithEmailAndPassword(me.usuario, me.contraseña)
          .then(function (response) {
            me.loading = false;
            me.verificarAuth();
            me.limpiar();
          })
          .catch(function (error) {
            me.loading = false;
            var errorCode = error.code;
            if (errorCode === "auth/invalid-email") {
              me.$toast.info("El correo es incorrecto");
            } else if (errorCode === "auth/user-not-found") {
              me.$toast.info("No se encontro el usuario registrado");
            } else if (errorCode === "auth/wrong-password") {
              me.$toast.info("Contraseña incorrecta");
            }
          });
      } else {
        this.$toast.info("Debe de completar los campos");
      }
    },

    datosUsuario(id) {
      let me = this;
      dbRealtimeUser
        .child(id)
        .once("value")
        .then(function (dataSnapshot) {
          if (dataSnapshot.val().estado == "activo") {
            me.logueado = true;
          } else {
            me.cerrarSesion();
          }
          me.loading = false;
        });
    },

    verificarAuth() {
      let me = this;
      me.loading = true;
      instanceWeb.auth().onAuthStateChanged(function (user) {
        if (user) {
          me.datosUsuario(user.uid);
        } else {
          me.loading = false;
        }
      });
    },

    cerrarSesion() {
      instanceWeb.auth().signOut();
      this.logueado = false;
    },

    limpiar() {
      this.usuario = "";
      this.contraseña = "";
    },
  },
};
</script>

<style scoped>
.cardBody {
  height: 100%;
  width: 100%;
  background-color: #023e8a;
}
</style>